













 import SignaturePad from 'signature_pad';

 /* ----------------------------------------
     Types
 ---------------------------------------- */

 import { Component, Prop, Vue } from 'vue-property-decorator';
 import Button from './Form/Button';

 /* ----------------------------------------
     Mixin
---------------------------------------- */

 import { componentMixin } from './../mixins/component';

 /* ----------------------------------------
     Component
 ---------------------------------------- */

 @Component({
     name: 'draw',

     data() {
         return {
             aliasNames: [
                 'canvas',
                 'actions',
                 'save',
                 'clear',
                 'download'
             ],
             data: {},
             _canvas: {},
             _signaturePad: {}
         };
     },

     components: {
         Button
     },

     mixins: [
         componentMixin
     ],

     mounted() {
         
         this._canvas = this.$el.querySelector('canvas');
         this._canvas.width = this.width || 640;
         this._canvas.height = this.height || 480;

         this._signaturePad = new SignaturePad(this._canvas, {
             minWidth: 1,
             maxWidth: 5,
             backgroundColor: 'rgba(255, 255, 255, 1)',
             penColor: 'rgb(0, 0, 0)'
         });

         if (this.image)
             this._signaturePad.fromDataURL(this.image);

         window.addEventListener('resize', this.resizeCanvas);
         this.resizeCanvas();
     },

     methods: {

         save(action) {
             if(this._signaturePad.isEmpty()) return;
             if (typeof action === 'function') return action();
             this.$emit('save', action, this._signaturePad);
         },

         clear() {
             this._signaturePad.clear();
             this.$emit('clear', this._signaturePad);
         },

         download(data = 'png', filename = this.classname) {
             const file = this.getImage(data);
             const name = `${ filename }_${ this.getTimestamp() }_${ file.exe }`;
             const a = document.createElement('a');

             a.setAttribute('href', file.image);
             a.setAttribute('download', name);

             a.style.display = 'none';
             document.body.appendChild(a);

             a.click();
             document.body.removeChild(a);

             this.$emit('download');
         },

         getImage(type) {
             let image = {};

             switch(type) {
                 case 'jpg':
                     image = {
                         exe: '.jpg',
                         type: 'image/jpeg',
                         image: this._signaturePad.toDataURL('image/jpeg')
                     };

                     break;
                 case 'svg':
                     image = {
                         exe: '.svg',
                         type: 'image/svg+xml',
                         image: this._signaturePad.toDataURL('image/svg+xml')
                     };

                     break;
                 default:
                     image = {
                         exe: '.png',
                         type: 'image/png',
                         image: this._signaturePad.toDataURL()
                     };
             }

             return image;
         },

         getTimestamp() {
             const date = new Date();
             return date.getTime();
         },
         
         resizeCanvas() {
             const ratio =  Math.max(window.devicePixelRatio || 1, 1);
             this._canvas.width = this._canvas.offsetWidth * ratio;
             this._canvas.height = this._canvas.offsetHeight * ratio;
             this._canvas.getContext('2d').scale(ratio, ratio);
             this._signaturePad.clear();
         }
     },
 })

 /* ----------------------------------------
     Export
 ---------------------------------------- */

 export default class Draw extends Vue {
     @Prop(String) width!: String;
     @Prop(String) height!: String;
     @Prop(Boolean) noDefault!: Boolean;
     @Prop(Boolean) noDownload!: Boolean;
     @Prop(Boolean) noSave!: Boolean;
     @Prop(Boolean) noClear!: Boolean;
     @Prop(String) image!: String;
 }

